import PropTypes from 'prop-types';
import PageHeader from './PageHeader';
import PageFooter from './PageFooter';
import BottomNav from './BottomNav';

/**
 * 頁面佈局容器組件 - 整合 Header、Footer、BottomNav
 * 支援響應式設計（手機/平板/桌面）
 * @param {Object} props
 * @param {React.ReactNode} props.children - 頁面內容
 * @param {Object} props.headerProps - Header 組件的 props
 * @param {Object} props.footerProps - Footer 組件的 props
 * @param {Object} props.bottomNavProps - BottomNav 組件的 props
 * @param {boolean} props.hideHeader - 是否隱藏 Header
 * @param {boolean} props.hideFooter - 是否隱藏 Footer
 * @param {boolean} props.hideBottomNav - 是否隱藏底部導航
 * @param {boolean} props.noPadding - 是否移除 main 的 padding（top + bottom）
 * @param {boolean} props.noPaddingTop - 是否移除 header 頂部間距
 * @param {boolean} props.noPaddingBottom - 是否移除 bottom nav 底部間距
 * @param {string} props.maxWidth - 最大寬度類別 ('md' | 'lg' | 'xl' | 'full')
 */
const PageLayout = ({
    children,
    headerProps = {},
    footerProps = {},
    bottomNavProps = {},
    hideHeader = false,
    hideFooter = false,
    hideBottomNav = false,
    noPadding = false,
    noPaddingTop = false,
    noPaddingBottom = false,
    headerHeight = 70,
    maxWidth = 'full',
    className = '',
}) => {
    // 響應式最大寬度配置
    const maxWidthClasses = {
        md: 'max-w-md',
        lg: 'max-w-4xl',
        xl: 'max-w-6xl',
        full: 'w-full',
    };

    return (
        <div className={`min-h-screen bg-[--color-background-light] text-stone-dark ${className}`}>
            {/* Header */}
            {!hideHeader && <PageHeader {...headerProps} />}

            {/* Main Content - 響應式寬度 */}
            <main
              className={`${!noPadding && !noPaddingBottom && !hideBottomNav ? 'pb-24 md:pb-8' : ''} ${maxWidthClasses[maxWidth]} mx-auto`}
              style={!noPadding && !noPaddingTop && !hideHeader ? { paddingTop: headerHeight } : {}}
            >
                {children}
            </main>

            {/* Footer */}
            {!hideFooter && <PageFooter {...footerProps} />}

            {/* Bottom Navigation - 桌面版隱藏 */}
            {!hideBottomNav && <BottomNav {...bottomNavProps} className="md:hidden" />}
        </div>
    );
};

PageLayout.propTypes = {
    children: PropTypes.node.isRequired,
    headerProps: PropTypes.object,
    footerProps: PropTypes.object,
    bottomNavProps: PropTypes.object,
    hideHeader: PropTypes.bool,
    hideFooter: PropTypes.bool,
    hideBottomNav: PropTypes.bool,
    noPadding: PropTypes.bool,
    noPaddingTop: PropTypes.bool,
    noPaddingBottom: PropTypes.bool,
    maxWidth: PropTypes.oneOf(['md', 'lg', 'xl', 'full']),
    className: PropTypes.string,
};

export default PageLayout;

